"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DashCard = exports.CardSection = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _polished = require("polished");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("./");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 2 / 3 / span 1 / span 1;\n  /* background: teal;  */\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 1 / 3 / span 1 / span 1;\n  /* background: wheat;  */\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 2 / 1 / span 1 / span 2;\n  /* background: orange;  */\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 1 / 1 / span 1 / span 2;\n  /* background: green;  */\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 1 / 3 / span 2 / span 1;\n  /* background: blue;  */\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  grid-area: 1 / 1 / span 2 / span 2;\n  /* background: red;  */\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: ", ";\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\npadding: ", ";\ndisplay: grid;\nalign-items: ", ";\n", ";\n", "\n", "\n", "\n", "\n", "\n", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n      & .flexi-card-icon{\n          right: -30px;\n      }\n    "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n      & .flexi-card-icon-i{\n        border: none;\n        border-radius: ", ";\n        font-size: 40px;\n      }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      & .flexi-card-icon-i{\n        border: 2px solid ", ";\n        border-radius: ", ";\n      }\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    & .flexi-card-icon{\n      position: absolute;\n      display: grid;\n      grid-template-columns: 1fr 1fr;\n      grid-template-rows: 1fr 1fr;\n      grid-gap: 10px;\n      bottom: 50%;\n      right: 0;\n      transform: rotateZ(45deg);\n      transition: ", ";\n      & .flexi-card-icon-i{\n        width: 60px;\n        height: 60px;\n        display: flex;\n        align-items: center;\n        opacity: 0.2;\n      }\n      ", "\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: grid;\n  /* max-width: 400px; */\n  min-height: 100px;\n  overflow: hidden;\n  position: relative;\n  /* grid-template-columns: 1fr 1fr 1fr;\n  grid-template-rows: 1fr 1fr 1fr; */\n  align-items: center;\n  border-radius: ", ";\n  color: ", ";\n  background: ", ";\n  ", ";\n  transition: ", ";\n  padding: 20px;\n  \n  ", "\n  &:hover{\n    ", ";\n    ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DashCardWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.theme.SecondaryRadius;
}, function (props) {
  return (0, _polished.readableColor)(props.color);
}, function (props) {
  return props.color;
}, function (props) {
  return props.theme.Elevate[props.elevate];
}, function (props) {
  return props.theme.PrimaryTransition;
}, function (props) {
  return props.icon && (0, _styledComponents.css)(_templateObject2(), function (props) {
    return props.theme.PrimaryTransition;
  }, function (props) {
    return typeof props.icon === 'boolean' ? (0, _styledComponents.css)(_templateObject3(), props.iconColor, props.theme.SecondaryRadius) : (0, _styledComponents.css)(_templateObject4(), props.theme.SecondaryRadius);
  });
}, function (props) {
  return props.theme.Elevate.high;
}, function (props) {
  return props.icon && (0, _styledComponents.css)(_templateObject5());
});

var CardSection = _styledComponents["default"].div(_templateObject6(), function (props) {
  return props.pad;
}, function (props) {
  return props.vAlign;
}, function (props) {
  return props.height && (0, _styledComponents.css)(_templateObject7(), function (props) {
    return props.height;
  });
}, function (props) {
  return props.left && (0, _styledComponents.css)(_templateObject8());
}, function (props) {
  return props.right && (0, _styledComponents.css)(_templateObject9());
}, function (props) {
  return props.topLeft && (0, _styledComponents.css)(_templateObject10());
}, function (props) {
  return props.bottomLeft && (0, _styledComponents.css)(_templateObject11());
}, function (props) {
  return props.topRight && (0, _styledComponents.css)(_templateObject12());
}, function (props) {
  return props.bottomRight && (0, _styledComponents.css)(_templateObject13());
});

exports.CardSection = CardSection;
CardSection.defaultProps = {
  pad: '5px',
  vAlign: 'center'
};
CardSection.propTypes = {
  left: _propTypes["default"].bool,
  right: _propTypes["default"].bool,
  bottomLeft: _propTypes["default"].bool,
  bottomRight: _propTypes["default"].bool,
  topLeft: _propTypes["default"].bool,
  topRight: _propTypes["default"].bool,
  pad: _propTypes["default"].string,
  vAlign: _propTypes["default"].string,
  height: _propTypes["default"].string
};

var DashCard = function DashCard(props) {
  return /*#__PURE__*/_react["default"].createElement(DashCardWrapper, props, props.icon && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-card-icon"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-card-icon-i"
  }, typeof props.icon != 'boolean' && props.icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-card-icon-i"
  }, props.icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-card-icon-i"
  }, props.icon), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flexi-card-icon-i"
  }, props.icon)), props.children);
};

exports.DashCard = DashCard;
DashCard.defaultProps = {
  elevate: "mid",
  color: '#fff'
};
DashCard.propTypes = {
  color: _propTypes["default"].string,
  elevate: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].string]),
  icon: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].element]),
  iconColor: _propTypes["default"].string
};